<page-header title="Create Container" [showSpinner]="isLoading" [error]="error"></page-header>

<container-form *ngIf="!isLoading" [container]="container" (formSubmit)="onSubmit($event)" (formCancelled)="onCancel($event)"></container-form>
